import _regeneratorRuntime from "@babel/runtime/regenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import ensureCartElements from '@sprinx/pricing-core/ensureCartElements';
import createSubject from '@sprinx/pricing-core/createSubject';
import useApplyPricingRulesHandler from '../useApplyPricingRulesHandler';
export default function useCalculateProductPriceHandler(applyRulesCtxPartial) {
  var applyPricingRulesHandler = useApplyPricingRulesHandler();
  return React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(product) {
      var quantity,
          subject,
          cart,
          _yield$applyPricingRu,
          _yield$applyPricingRu2,
          _yield$applyPricingRu3,
          nextCart,
          noTaxPrices,
          _nextCart$subjects,
          _nextCart$subjects$,
          discountAbsolute,
          discountPercent,
          price,
          priceOriginal,
          priceOriginalWithTax,
          priceWithTax,
          taxes,
          taxInfo,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              quantity = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
              _context.next = 3;
              return createSubject(null, {
                product: product,
                quantity: quantity
              });

            case 3:
              subject = _context.sent;
              _context.next = 6;
              return ensureCartElements({
                subjects: [subject]
              });

            case 6:
              cart = _context.sent;
              _context.next = 9;
              return applyPricingRulesHandler(applyRulesCtxPartial, cart);

            case 9:
              _yield$applyPricingRu = _context.sent;
              _yield$applyPricingRu2 = _slicedToArray(_yield$applyPricingRu, 2);
              _yield$applyPricingRu3 = _yield$applyPricingRu2[1];
              nextCart = _yield$applyPricingRu3.cart;
              noTaxPrices = _yield$applyPricingRu3.noTaxPrices;
              _nextCart$subjects = _slicedToArray(nextCart.subjects, 1), _nextCart$subjects$ = _nextCart$subjects[0], discountAbsolute = _nextCart$subjects$.discountAbsolute, discountPercent = _nextCart$subjects$.discountPercent, price = _nextCart$subjects$.price, priceOriginal = _nextCart$subjects$.priceOriginal, priceOriginalWithTax = _nextCart$subjects$.priceOriginalWithTax, priceWithTax = _nextCart$subjects$.priceWithTax, taxes = _nextCart$subjects$.taxes, taxInfo = _nextCart$subjects$.taxInfo;
              return _context.abrupt("return", {
                noTaxPrices: noTaxPrices,
                price: price,
                priceWithTax: priceWithTax,
                priceOriginal: priceOriginal,
                priceOriginalWithTax: priceOriginalWithTax,
                discountAbsolute: discountAbsolute,
                discountPercent: discountPercent,
                taxInfo: taxInfo,
                taxes: taxes
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [applyPricingRulesHandler, applyRulesCtxPartial]);
}